import { Field, FieldProps } from 'formik'
import { FormikFieldProps } from './FieldProps'
import TextArea, { TextAreaProps } from 'antd/lib/input/TextArea'
import { MaxCharactersWrapper } from './MaxCharactersWrapper'
import { E2EAttributes } from '../../shared/types'

export type InputProps = (FormikFieldProps &
  TextAreaProps & { autoSize: { minRows: number; maxRows: number } | false; placeholder: string }) & {
  showMaxCharacters?: {
    max: number
    description?: string
    warningText?: string
  } & E2EAttributes
}

export const FormikTextArea = ({
  name,
  validate,
  autoSize,
  placeholder,
  maxLength,
  showMaxCharacters,
  ...restProps
}: InputProps): JSX.Element => {
  const textArea = (value: string | number | readonly string[] | undefined, onChange, onBlur) => (
    <TextArea
      name={name}
      value={value}
      autoSize={autoSize}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
      maxLength={showMaxCharacters ? showMaxCharacters.max : maxLength}
      {...restProps}
    />
  )

  return (
    <Field name={name} validate={validate}>
      {({ field: { value, onChange, onBlur } }: FieldProps) =>
        showMaxCharacters ? (
          <MaxCharactersWrapper
            usedCharacters={value.length}
            maxCharacters={showMaxCharacters.max}
            maxCharactersDescription={showMaxCharacters.description}
            warningText={showMaxCharacters.warningText}
          >
            {textArea(value, onChange, onBlur)}
          </MaxCharactersWrapper>
        ) : (
          textArea(value, onChange, onBlur)
        )
      }
    </Field>
  )
}
